const updateItems = [
  { date: '2026.07.31', title: '《流浪地球3》高清版正式上线糖心影视', tag: '新片上线' },
  { date: '2026.07.30', title: '糖心影视暑期专题页全新改版，观影体验再升级', tag: '平台动态' },
  { date: '2026.07.28', title: '国漫专区新增50部经典动画电影高清修复版', tag: '内容更新' },
  { date: '2026.07.25', title: '糖心影视移动端播放器优化完成，加载速度提升40%', tag: '技术升级' },
  { date: '2026.07.22', title: '悬疑推理分类新增《暗夜追踪》《迷雾剧场》等热播剧', tag: '内容更新' },
  { date: '2026.07.19', title: '糖心影视纪录片频道上线BBC、NHK精品系列', tag: '新片上线' },
  { date: '2026.07.15', title: '用户反馈系统全新上线，您的建议我们认真倾听', tag: '平台动态' },
  { date: '2026.07.10', title: '暑期档观影指南专题发布，一站式掌握最新大片', tag: '专题策划' },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950">
            最新动态
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-500">
            糖心影视平台的每一次进步，都与你有关
          </p>
        </div>

        <div className="relative">
          <div className="absolute left-4 md:left-5 top-2 bottom-2 w-px bg-background-200"></div>

          <div className="space-y-6">
            {updateItems.map((item, idx) => (
              <div key={idx} className="relative flex items-start gap-5 md:gap-7 pl-10 md:pl-12">
                <span className="absolute left-0 top-1 w-3 h-3 md:w-3.5 md:h-3.5 rounded-full bg-primary-500 border-4 border-background-50 flex-shrink-0 z-10"></span>
                <span className="text-xs text-foreground-400 whitespace-nowrap mt-0.5 font-medium min-w-[80px]">{item.date}</span>
                <div>
                  <span className={`inline-block px-2 py-0.5 text-[10px] font-semibold rounded whitespace-nowrap mb-1.5 ${
                    item.tag === '新片上线' ? 'bg-primary-100 text-primary-700' :
                    item.tag === '平台动态' ? 'bg-accent-100 text-accent-700' :
                    item.tag === '内容更新' ? 'bg-secondary-100 text-secondary-700' :
                    item.tag === '技术升级' ? 'bg-secondary-100 text-secondary-700' :
                    'bg-primary-100 text-primary-700'
                  }`}>
                    {item.tag}
                  </span>
                  <p className="text-sm md:text-base text-foreground-800 font-medium leading-relaxed">
                    {item.title}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}